import highlightHero from "./highlight-hero";
import highlightHotspots from "./highlight-hotspots";
import highlightMonsters from "./highlight-monsters";

export { highlightHero, highlightMonsters, highlightHotspots };
